import './CarStop.css';

import * as cardService from "../services/cardServices";
import * as http from "../services/httpServices";
import * as utils from "../services/utilsServices";

import React, { Component } from 'react';

import CustomModal from './CustomModal'
import Mapir from "mapir-react-component";
import { MenuBottomGeo } from "./MenuBottomGeo";
import { mapApiKey } from "../config.json";
import { toast } from "react-toastify";

export class CarStop extends Component {
    static displayName = CarStop.name;
    state = { 
        showModal:false,
        state:-1,


    };


    componentDidMount() {
        let choice = cardService.getChoiceCard();
        console.log('choiceddd', choice);
        if (choice == []) {
            toast.error('دستگاه فعال مشخص نشده است')
            this.props.history.replace({ pathname: '/main' });
        }
        this.setState({ choiceDevice: choice });

    }

    doCar=(e,state)=>{
        e.preventDefault();
        this.setState({state:state, showModal:true});
    }

    doAction=(e)=>{
       e.preventDefault();
       utils.sendSms(this.state.choiceDevice.deviceNumber, `stop,${this.state.state}`);
       toast.dark('لطفا تا دریافت پیام از دستگاه صبر کنید');
       this.setState({showModal:false});
       return;        
    }

    render() {

        return (
            <> 
            <div className=" modal fade  show " style={{display: this.state.showModal ? 'block' : 'none' }}
            name="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className=" modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                    {/*
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" 
                            aria-label="Close"
                            onClick={(e)=>onClose(e)}
                            ></button>
                    </div>*/}
                        <div className="modal-body">
                            آیا از انجام این عملیات مطمئن هستید؟
                        </div>
                        <div className="modal-footer">    
                        <button className="btn btn-outline-dark" onClick={(e)=>this.doAction(e)}>بلی</button>
                        <button className="btn btn-outline-dark" onClick={(e)=>{this.setState({showModal:false})}}>خیر</button>
                        </div>
                    </div>
                </div>
            </div>
      
                <div className="container-fluid" id="containerCarStop">
                    <div className="row" >
                        <div className="col text-center" >
                            <img src="/images/stop.png" id="stopImg" />
                        </div>
                    </div>
                    <div className="row" >
                        <div className="col  text-center" >
                            <div>توقف خودرو</div>
                        </div>
                    </div>
                    <div className="row" >
                        <div className="col p-2" id="choiceStopCar">
                            <div className="d-flex" onClick={(e)=>this.doCar(e,"0")}>
                                <div className="p-2 flex-fill" justify-content-center>
                                    اجازه روشن کردن موتور
                                </div>
                            </div>
                            <div className="d-flex" onClick={(e)=>this.doCar(e,"1")}>
                                <div className="p-2 flex-fill" justify-content-center>
                                    خاموش کردن فوری موتور
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <MenuBottomGeo />
            </>

        );
    }


}